import { FC } from 'react';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuestion, selectQuiz } from 'store/quiz/quizSelectors';
import { selectQuestionReady } from 'store/player/playerSelectors';
// Types
import QuizTypes from 'types/QuizTypes';

type Props = {
  width: number;
}

const BeatTheExpertScoringBar:FC<Props> = ({ width }) => {
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const question = useAppSelector(selectQuestion);
  const questionReady:boolean = useAppSelector(selectQuestionReady);

  if ( !questionReady || quiz.type !== QuizTypes.BeatTheExpert || !question.timeout ) return null;
  return (
    <div className="px-4 mb-2">
      <div
        className="relative w-full bg-gray-200 border-4 border-gray-200 h-6 rounded-lg"
        style={{ marginBottom: 2 }}
      >
        <div className="absolute top-0 left-0 w-full h-4 opacity-25 rounded z-0" style={{ backgroundColor: quiz.theme.progressBarColor }}></div>
        <div className="absolute top-0 left-0 h-4 rounded z-10" style={{ width: `${width}%`, backgroundColor: quiz.theme.progressBarColor }}></div>
      </div>
    </div>
  )
}

export default BeatTheExpertScoringBar;
